import script from "./AppHero.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHero.vue?vue&type=script&setup=true&lang=js"

import "./AppHero.vue?vue&type=style&index=0&id=3cfdd862&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cfdd862"]])

export default __exports__